import { render, staticRenderFns } from "./GoodTableAdvanceSearch.vue?vue&type=template&id=066bc65b"
import script from "./GoodTableAdvanceSearch.vue?vue&type=script&lang=js"
export * from "./GoodTableAdvanceSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports